module.exports = __webpack_public_path__ + "static/media/icon-paint.41e871eb.svg";